import React from 'react'
import styled from 'styled-components'

import { costaTextBold } from 'ui/src/styles'

function LabelCTA({
  className,
  arrowDirection = 'right',
  children,
  labelLink,
  color = '#6d1f37',
  onClick,
  target,
  dataCy,
}) {
  return (
    <Link
      tabIndex="0"
      role="link"
      className={className}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick()
        }
      }}
      arrowDirection={arrowDirection}
      onClick={onClick}
      href={labelLink}
      color={color}
      target={target}
      data-cy={dataCy}
    >
      {children}
    </Link>
  )
}

const Link = styled.a`
  color: ${({ color }) => color};
  display: flex;
  align-items: center;
  height: 24px;
  ${costaTextBold};
  ${({ arrowDirection, color }) =>
    arrowDirection === 'right'
      ? `
  :after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    border-right: 2px solid ${color};
    border-bottom: 2px solid ${color};
    transform: rotate(-45deg);
    margin-right: 8px;
    vertical-align: middle;
  }`
      : `:before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        border-left: 2px solid ${color};
        border-top: 2px solid ${color};
        transform: rotate(-45deg);
        margin-right: 8px;
        vertical-align: middle;
  }`}
`

export default LabelCTA
